import { GetterTree } from 'vuex'
import { BrandModule } from '..'
import { CheckboxNode } from '../../types'
import { toFilterSets } from '../../utils/filters/filters.generics'

export const getters: GetterTree<typeof BrandModule['state'], unknown> = {
  brandsAsTreeNodes(state): CheckboxNode {
    return {
      name: 'Brand',
      id: 'all_brands',
      groupingKey: 'brand',
      type: 'Checkbox',
      children: [
        ...toFilterSets(state.all, brand => {
          return {
            id: brand._id,
            value: brand._id,
            name: brand.name,
            groupingKey: 'brand',
            type: 'Checkbox'
          }
        }),
        {
          id: 'brand_not_set',
          value: null,
          name: 'Not Set',
          groupingKey: 'brand',
          type: 'Checkbox'
        }
      ]
    }
  }
}
